/* eslint-disable camelcase */
import { PersonalizedSurveyProps } from '../../components/Modals/AddSurveyModal/addSurveyInterface';
import apiFetch from '../apiFetch';
import generateHeaders from '../myHeaders';

const updateSurvey = (
    surveyId: number,
    survey: PersonalizedSurveyProps,
    selectedSchema: string,
): Promise<unknown> => {
    const payload = {
        id: survey.id,
        schema_name: survey.schema,
        name: survey.name,
        slug: survey.shortName,
        display: survey.display,
        activate_synchronization: survey.hasAutomaticSynchronization,
        default_weight: false,
        rank: 0,
        status: survey.status,
        temporal_filter_type: survey.temporalFilterType,
        default_date_period: survey.defaultDatePeriod,
        context: survey.context,
        has_quartile: false,
        can_export_hot_alert: survey.hasHotAlert,
        can_create_dashboard: survey.hasDashboard,
        has_to_anonymate_responses: survey.hasToAnonymateData,
        anonymization_limit_days: survey.anonymateDays ?? null,
        has_translation: false,
    };

    return apiFetch(
        `${process.env.REACT_APP_API_URL}/configuration/surveys/${surveyId}`,
        { method: 'PUT', headers: generateHeaders(selectedSchema), body: JSON.stringify(payload) },
    );
};

export default updateSurvey;
